import { useSyncExternalStore } from 'react';

/** Name of the focused route (updated from NavigationContainer.onStateChange). */
let current: string | undefined;
const subs = new Set<() => void>();

export function setCurrentRoute(name: string | undefined) {
  if (name === current) return;
  current = name;
  subs.forEach((f) => f());
}

export function useCurrentRoute() {
  return useSyncExternalStore(
    (cb) => {
      subs.add(cb);
      return () => subs.delete(cb);
    },
    () => current,
  );
}
